export default {
  login: {
    login_name: "login.login_name", //登录标题
    login_label: "login.login_lable", //登录
    login_label_microsoft: "login.login_lable_microsoft", //微软验证
    account_info: "login.account_info", //账户信息
    company_website: "login.company_website", //公司网站
    product: "login.product", //产品
    contact: "login.contact", //联系方式
    quick_links: "login.quick_links", //快速链接
    about_stora_enso: "login.about_stora_enso", //集团简介
    careers: "login.careers", //加入我们
    download_centre: "login.download_centre", //下载中心
    newsroom: "login.newsroom", //新闻中心
    sustainability: "login.sustainability" //可持续发展
  },
  CompanyInfo: {
    search: "CompanyInfo.search",
    query: "CompanyInfo.query",
    CompanyInfoList: "CompanyInfo.CompanyInfoList",
    CompanyInfoName: "CompanyInfo.CompanyInfoName",
    All: "CompanyInfo.All"
  }
};
